// Access and refresh tokens are kept in JavaScript memory only (VAPT Finding 1).
// They are never written to localStorage, sessionStorage, IndexedDB or cookies,
// so they are lost on page reload or tab close and the user must log in again.

let accessToken: string | null = null;
let refreshToken: string | null = null;

export function setTokens(tokens: {
  access_token?: string | null;
  refresh_token?: string | null;
}) {
  accessToken = tokens.access_token || null;
  refreshToken = tokens.refresh_token || null;
}

export function setAccessToken(token: string | null) {
  accessToken = token || null;
}

export function setRefreshToken(token: string | null) {
  refreshToken = token || null;
}

export function getAccessToken() {
  return accessToken;
}

export function getRefreshToken() {
  return refreshToken;
}

export function hasSession() {
  return accessToken !== null;
}

export function clearTokens() {
  accessToken = null;
  refreshToken = null;
}
